import Rollbar from 'rollbar'
import { getCookie } from '../utilities/cookies'

export const createRollbarClient = (userId: string, token: string) => {
  let env = process.env.UBIK_ENV
  env = env || 'prod'
  if (env !== 'prod' || window.location.href.includes('.vpsvc.com') || window.location.href.includes('localhost')) {
    return undefined
  }

  return new Rollbar({
    autoInstrument: false,
    accessToken: token,
    captureUncaught: true,
    captureUnhandledRejections: true,
    environment: env,
    // TO DO: use tenant name function to get tenant name after migration of code
    host: new URLSearchParams(window.location.search).get('source') || '',
    hostBlockList: [
      'b-code.liadm.com',
      'cdn.quantummetric.com',
      // 'hidden' is an attempt to block errors raised from Safari extensions. These show up as 'webkit-masked-url://hidden/'
      'hidden',
      'googletagmanager.com',
      'siteintercept.qualtrics.com',
    ],
    payload: {
      client: {
        javascript: {
          source_map_enabled: true,

          code_version: process.env.UBIK_CODE_VERSION,

          guess_uncaught_frames: true,
        },
      },

      qm_session_id: getCookie('QuantumMetricSessionID'),
      time_stamp: Date.now(),
    },
    ignoredMessages: ['Script error.'],
  }).configure({ payload: { user: { shopperId: userId }, ubik: true } })
}
